import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const baseRoute = `${BASE_PATH_API}/settings/eventHistory`;

const actions = {
    save: {
        url: baseRoute,
        method: 'POST'
    },

    remove: {
        url: `${baseRoute}/:id`,
        method: 'DELETE'
    },

    update: {
        url: `${baseRoute}/:id`,
        method: 'PUT'
    },

    query: {
        url: baseRoute,
        method: 'GET'
    }
};

export function EventHistorySettingsApi() {
    return createActions(actions);
}
